import './NoResult.css';
import React from 'react';
import { useTranslations } from '../../../../hooks/use-translations.hook';

export const NoResult = () => {
    const { t } = useTranslations();

    return (
        <div className="asg-search-results-empty">
            <div className="asg-search-results-empty__icon" />
            <div className="asg-search-results-empty__text">{t('noResults')}</div>
        </div>
    );
};
